import { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import calLogo from '../../assets/images/calender.svg';
import dummyImg from "../../assets/images/dummy.svg";
import authContext from "../../context/authContext";
import ProfileImage from "../../components/layouts/ProfileImage";

import { Link, useNavigate } from "react-router-dom";
import { Routes } from "../../constants/RouteConstants";
import Button from "../../components/ui/Button";
import SelectMonthAndYearModalForOppertunityCost from "../contributions/SelectMonthAndYearModalForOppertunityCost";
import chevRight from '../../assets/images/chev-right.svg'
import { setDateHelper, getBudgetPeriodDates } from "../../utils/Helper";
import moment from "moment";
import { ApiConstants } from "../../constants/ApiConstants";
import useMakeRequest from "../../utils/ApiHelper";


interface memberDetails {
    claimed_opportunity_hours: number
    final_value: number
    id: number
    name: string
    opportunity_cost_bonus: number
    total_chores_price: number
    total_hours: number
    maximum_opportunity_cost_hourse: number
    current_opportunity_hours: number
    isClaimed: boolean
    isEligiable: boolean
    profile_pic?: string | null
}

interface contributionsInputs {
    start_date: string;
    end_date: string;
    total_completed_hours: number;
    average: number;
    members: memberDetails[];
    is_finalized: number | null;
    prevRate: string;
    prevHours: string;
    prevDesc: string;
    prevClaimedUsers: any[]
}
const ContributuonReportPopup = () => {
    const navigate = useNavigate();
    let profile: any = useContext(authContext);

    const oppertunityCost = useMakeRequest();

    const [refetchData, setRefetchData] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [oppertunityCostItems, setOppertunityCostItems] = useState<contributionsInputs>(
        {
            start_date: "",
            end_date: "",
            total_completed_hours: 0,
            average: 0,
            members: [],
            is_finalized: null,
            prevRate: '0',
            prevHours: '0',
            prevDesc: "",
            prevClaimedUsers: []
        }
    );

    useEffect(() => {
        if (!oppertunityCostItems?.start_date && !oppertunityCostItems?.end_date) {
            // Calculate current month’s start date based on billingDate
            const { startDate, endDate } = getBudgetPeriodDates(
                moment().year(),
                moment().month(),
                profile?.data?.hh_member?.household?.billing_date || 1
            );

            // ✅ set state so UI shows dates
            setOppertunityCostItems({
                ...oppertunityCostItems,
                start_date: startDate,
                end_date: endDate,
            });

            // ✅ also set current month name
            setSelectedMonth(moment().format("MMMM"));

            oppertunityCost.makeRequest({
                url: ApiConstants?.OppertunityCostCheck,
                payload: {
                    month: moment().month(),
                    start_date: startDate,
                    end_date: endDate,
                },
            })
        }
    }, []);  // only run once at mount


    useEffect(() => {
        if (oppertunityCost?.status) {
            console.log("oppertunityCost?.data?.data?.total?.previousUserEnteredHours: ", oppertunityCost?.data?.data?.total)
            setOppertunityCostItems({
                start_date: oppertunityCost?.data?.data?.total?.start_date,
                end_date: oppertunityCost?.data?.data?.total?.end_date,
                total_completed_hours: oppertunityCost?.data?.data?.total?.total_completed_hours || 0,
                prevRate: oppertunityCost?.data?.data?.total?.previousClaimedRate || 0,
                prevHours: oppertunityCost?.data?.data?.total?.previousUserEnteredHours || 0,
                prevDesc: oppertunityCost?.data?.data?.total?.previousDescription || "",
                average: oppertunityCost?.data?.data?.total?.average || 0,
                members: oppertunityCost?.data?.data?.members || [],
                is_finalized: oppertunityCost?.data?.data?.total?.is_finalized,
                prevClaimedUsers: oppertunityCost?.data?.data?.total?.previousClaimsDetails
            })

        }

    }, [oppertunityCost?.status])

    const filterderdClaimedMembers = [
        ...(oppertunityCostItems?.members?.filter((m) => m.isEligiable) || []),
        ...(oppertunityCostItems?.members?.filter((m) => !m.isEligiable) || [])
    ];


    return (
        <div className="costs-page">
            <header role="banner">
                <h1 className='head-title'>
                    Opportunity Costs <Link className='ms-auto' to={Routes?.Reports} state={{ activeTab: "contributions" }} aria-label="Close Report"><i className='icon-close-circle' aria-hidden="true"></i></Link>
                </h1>
            </header>
            <main id="main-content">
                <div className="page-padding-x">
                    <div className="col-12">
                        <div className="com-input-grp">
                            {/* <label className="form-label">Select Budget Period</label> */}
                            <button
                                type="button"
                                onClick={() => {
                                    const modal: any = $("#selectDateModalOppertunityCost");
                                    modal.modal("show");
                                }}
                                className=" mb-2 date-modal-btn"
                            >
                                {selectedMonth}
                                <img
                                    className="up-down-arw"
                                    src={chevRight}
                                    alt=""
                                />
                            </button>
                        </div>
                    </div>
                    <div className="row mb-4 pt-3">
                        <div className="col-6">
                            <div className="com-input-grp disabled-input-grp">
                                <label className="form-label">Start Date</label>
                                <DatePicker
                                    className="form-control"
                                    placeholderText="MM/DD/YYYY"
                                    timeFormat="MM DD YYYY"
                                    onKeyDown={(e: any) => e.preventDefault()}
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={50}
                                    disabled
                                    selected={oppertunityCostItems?.start_date as any}
                                    showIcon
                                    icon={
                                        <>
                                            <img className="calIcon" src={calLogo} alt="" />
                                        </>
                                    }
                                />
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="com-input-grp disabled-input-grp">
                                <label className="form-label">End Date</label>
                                <DatePicker
                                    className="form-control"
                                    placeholderText="MM/DD/YYYY"
                                    timeFormat="MM DD YYYY"
                                    onKeyDown={(e: any) => e.preventDefault()}
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={50}
                                    disabled
                                    selected={oppertunityCostItems?.end_date as any}
                                    showIcon
                                    icon={
                                        <>
                                            <img className="calIcon" src={calLogo} alt="" />
                                        </>
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className='cost-info-box'>
                                <div className='info-row'>
                                    <span className='info-label'>Completed Hours of Chores</span>
                                    <span className='info-value'>{oppertunityCostItems.total_completed_hours}</span>
                                </div>
                                <div className='info-row'>
                                    <span className='info-label'>Average</span>
                                    <span className='info-value'>{Number(oppertunityCostItems.average).toFixed(2)}</span>
                                </div>
                            </div>
                        </div>

                        {filterderdClaimedMembers?.length > 0 && filterderdClaimedMembers.map((member: memberDetails) => (
                            <div className="member-details-card" key={member.id}>
                                <div className="member-card-head">
                                    <ProfileImage src={member?.profile_pic} size={25} />
                                    <span className="member-card-name ms-2">{member.name}</span>
                                </div>
                                <div className="member-card-body">
                                    <div className="row gy-2">
                                        <div className="member-card-item-header">
                                            <div className="member-card-item-label">Chores Completed</div>
                                            <div className="member-card-item-value">{member.total_hours} hrs</div>
                                        </div>
                                        <div className="member-card-item-header">
                                            <div className="member-card-item-label">Maximum Opportunity-Cost Hours</div>
                                            <div className="member-card-item-value">{Number(member.maximum_opportunity_cost_hourse).toFixed(2)} hrs</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                    <div className="py-4">
                        <Button
                            className="com-btn"
                            style={{ width: "100%" }}
                            onClick={() => navigate(Routes?.Reports, { state: { activeTab: "contributions" } })}
                        >
                            Done
                        </Button>
                    </div>
                </div>
            </main>
            <SelectMonthAndYearModalForOppertunityCost
                billingDate={profile?.data?.hh_member?.household?.billing_date}
                refetchData={refetchData}
                onContinue={(e: any) => {
                    setOppertunityCostItems(e);
                }}
                selectMonth={setSelectedMonth}
            />
        </div>
    )
}

export default ContributuonReportPopup